export enum FeatureFlags {
  AppInsights = 'APP_INSIGHTS',
  ExoticPinkPtarmigan = 'EXOTIC_PINK_PTARMIGAN',
  Watchlist = 'WATCHLIST',
}
